<template>
  <Container type="card-full">
    <!-- <div slot="header">
        <el-button @click="addPmmx" :loading="btnLoading" v-if="showButton == 0">新增</el-button>
        <el-button @click="chgPmmx" :loading="btnLoading" v-if="showButton == 0">修改</el-button>
        <el-button @click="delPmmx" :loading="btnLoading" v-if="showButton == 0">删除</el-button>
    </div> -->
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{project.projectcode}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{project.projectno}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{project.pcomfullname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{project.projectname}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="split-line"></div>
    <vggrid :list="list" tableheight="600" flexname=""
      :cols="cols" :showfooter="false" :showPage="false"
      :resizable="true" :total="query.total"
      @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
    >
      <template slot="btn">
          <vxe-button icon="el-icon-plus" @click="addPmmx" v-if="showButton == 0" status="perfect">新增</vxe-button>
          <vxe-button icon="el-icon-upload2" @click="importPmmx" v-if="showButton == 0" status="perfect">从Excel导入</vxe-button>
      </template>
    </vggrid>
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="600px"
               :modal-append-to-body="false">

        <div class="file">
          <div>
            <upload-btn @changed='importData' text="采购清单导入"></upload-btn>
          </div>
          <div class="excel">请点击下载
            <span @click="downloadfile">《采购清单导入模板.xlsx》</span>
          </div>

        </div>

    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import uploadBtn from '../common/uploadBtn.vue'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pmmxIndex',
    data () {
      return {
        dialogVisible: false,
        dialogType: 0,
        dialogTitle: '',
        project: this.$route.params.form,
        list: [],
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'pmmxname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'unitname', fieldtype: 'I', title: '单位',calculExpr:'',addNewRowFlg: false},
          { field: 'pmmmake', fieldtype: 'I', title: '品牌',calculExpr:'',addNewRowFlg: false},
          { field: 'pmmspec', fieldtype: 'I', title: '规格',calculExpr:'',addNewRowFlg: false},
          { field: 'pmmtype', fieldtype: 'I', title: '型号',calculExpr:'',addNewRowFlg: false},
          { field: 'pmmxqty', fieldtype: 'F', title: '数量',calculExpr:'',addNewRowFlg: false},
          { field: 'pmmxremark', fieldtype: 'C', title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        pmmx: {},
        query: {
          projectid: this.$route.params.form.projectid,
          total: 0,
          limit: 20,
          offset: 0
        },
        isOperate:true,
        operateBtn:[
          {btncode:'CHG',btnicon:'el-icon-edit-outline',btnname:'修改'},
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        showButton:Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      }
    },
    created () {
      this.$on('CHG', () => this.chgPmmx())
      this.$on('DEL', () => this.delPmmx())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid,uploadBtn},
    deactivated () {
      this.$destroy()
    },
    methods: {
      downloadfile () {
        var tempwindow = window.open('_blank')
        tempwindow.location = this.excelPath
      },
      async importData (path, filename){
        console.log(path, this.$store.getters.uploadAddr)
        let data = await request({
          url: '/xmgl/project/importPmmx',
          method: "post",
          data: {projectid: this.$route.params.form.projectid, path: path.replace(this.$store.getters.uploadAddr, 'upload/')}
        })
        // this.deleteFile(path)
        if (data) {
          this.$message.warning(data)
        } else {
          this.$message.success('数据导入成功')
          this.getPageList()
          this.dialogClose()
        }

      },
      dialogClose () {
        this.dialogVisible = false
        this.dialogType = 0
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.pmmx = row
        this.$emit(code,row)
      },
      async init() {
        this.query = {
          projectid: this.$route.params.form.projectid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.pmmx = {}
        this.showButton = Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      },
      async close() {
        let returnForm = 'projectIndex'
        if (this.project.projecttype === '2') {
          returnForm = 'projectZjIndex'
        }
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      },
      async addPmmx () {
        console.log(this.project)
        if (this.project.projectstatus!=='10') {
          this.$message.warning('项目公告已发布，不能新增品目！')
          return
        }
        let form = {
          pmmxid: 0,
          pmmxprojectid: this.project.projectid,
          project: this.project
        }
        this.$router.push({name: 'pmmxForm', params: {form: form, type: 1}})
      },
      async chgPmmx () {
        // this.pmmx = row
        if (!this.project.projectid) {
          this.$message.warning('请选择一行!')
          return
        }
        if (this.project.projectstatus!=='10') {
          this.$message.error('项目公告已发布，不能修改品目！')
          return
        }
        this.pmmx.project = this.project
        this.$router.push({name: 'pmmxForm', params: {form: this.pmmx, type: 2}})
      },
      importPmmx () {
        this.dialogVisible = true
        this.dialogType = 1
        this.dialogTitle = '导入'
      },
      async delPmmx (row) {
        this.pmmx = row
        if (!this.project.projectid) {
          this.$message.warning('请选择一行!')
          return
        }
        if (this.project.projectstatus!=='10') {
          this.$message.error('项目公告已发布，不能删除品目！')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xmgl/project/delPmmx',
            method: "post",
            data: this.pmmx
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellClick (row) {
        this.pmmx = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPmmxList',
          params: this.query
        })
        console.log(res)
        res.forEach(e => {
            e.pmmxqty = utils.comdify(e.pmmxqty)
        });
        this.list = res
        this.loading = false
      }
    },
    filters: {
    },
    computed: {
      excelPath () {
        return this.$store.getters.uploadAddr + 'upload/file/采购清单导入模板.xlsx'
      }
    }
  }
</script>
<style lang="scss" scoped>
  .name {
    padding-bottom: 10px;
    span {
      color: #999999;
    }
  }
  .file {
    display: flex;
    align-items: center;
    .excel {
      padding-left: 10px;
      span {
        color: #409EFF;
        cursor: pointer;
      }
    }
  }
</style>
